class MobileMenu {
	isOpen = false;
	stateClasses = {
		open: 'mobile-menu--open',
	};
	constructor($el, $open, $close, $backdrop) {
		this.$el = $el;
		this.$open = $open;
		this.$close = $close;
		this.$backdrop = $backdrop;
		this.init();
	}

	init = () => {
		this.$open.on('click', this.open);
		this.$close.on('click', this.close);
		this.$backdrop.on('click', this.close);
	};

	open = () => {
		window._$html.addClass(this.stateClasses.open);
		window._$html.addClass('noscroll');
		this.isOpen = true;

		$(document).on('keyup', this.escapeHandler);
	};

	close = () => {
		window._$html.removeClass(this.stateClasses.open);
		window._$html.removeClass('noscroll');

		$(document).off('keyup', this.escapeHandler);
	};

	escapeHandler = e => {
		if (e.key === 'Escape') {
			this.close();
		}
	};
}

export default MobileMenu;
